import type { BundleChip, BundleChipTone } from '../../shared/bundleChip';

const TONE_CLASSES: Record<BundleChipTone, string> = {
  // Approved.
  success: 'bg-success/10 border-success/30 text-success',
  // Ready for review — the loudest chip, solid fill so it draws the eye.
  accent: 'bg-accent border-accent text-accent-fg',
  // Feedback sent, waiting on Henry.
  tint: 'bg-accent/10 border-accent/25 text-accent',
  // Coming soon.
  neutral: 'bg-page border-line text-muted',
};

export default function BundleChipBadge({ chip }: { chip: BundleChip }) {
  return (
    <span
      className={`
        inline-flex items-center px-2.5 py-1 rounded-full border
        font-mono text-[10px] uppercase tracking-[0.1em] font-semibold
        ${TONE_CLASSES[chip.tone]}
      `}
    >
      {chip.label}
    </span>
  );
}
